import React from 'react';
import { useProxyUrl } from '@sierralabs/core-ui';
import { parseFilePath } from '../common/parseFilePath';
import { FILE_TYPES } from '../constants/fileTypes';
import CSVViewer from './CSVViewer';
import MSOfficeLiveViewer from './MSOfficeLiveViewer';
import PDFViewer from './PDFViewer';
import UnrenderedFilesViewer from './UnrenderedFilesViewer';
const DocumentViewer = props => {
    const { title, storageKey, fileSize, componentProps } = props;
    // console.debug('storageKey', storageKey);
    const { ext } = parseFilePath(storageKey);
    // console.debug('ext', ext);
    const extension = ext.replace('.', '');
    const url = useProxyUrl(storageKey, { key: 'storageKey', path: 'files/proxy' }, undefined, true).toString();
    // console.debug('url', url);
    if (extension === 'pdf') {
        return React.createElement(PDFViewer, Object.assign({ key: url, url: url }, componentProps));
    }
    if (FILE_TYPES.msoffice.includes(extension)) {
        return (React.createElement(MSOfficeLiveViewer, Object.assign({ key: url, url: url || '', title: title || 'Document' }, componentProps)));
    }
    if (FILE_TYPES.images.includes(extension)) {
        return (React.createElement("img", Object.assign({ key: url, src: url, width: '100%', alt: title }, componentProps)));
    }
    if (FILE_TYPES.text.includes(extension) ||
        FILE_TYPES.video.includes(extension) ||
        FILE_TYPES.audio.includes(extension)) {
        return (React.createElement("iframe", Object.assign({ key: url, title: title, src: url, width: '100%', height: '100%' }, componentProps)));
    }
    if (extension === 'csv') {
        return React.createElement(CSVViewer, Object.assign({ fileUrl: url }, componentProps));
    }
    return (React.createElement(UnrenderedFilesViewer, Object.assign({ fileName: title + '.' + extension, fileSize: fileSize }, componentProps)));
};
export default DocumentViewer;
//# sourceMappingURL=DocumentViewer.js.map